/*
 Golden Partner Holding Website
 Created by Hu Fang.
 Copyright © GPHolding.ch. All rights reserved.
*/

import Vue from 'vue'
import Router from 'vue-router'

// import Home_cote_pc from './views/pc/Home_cote_pc.vue'
// const Home_cote_pc = () => import('./views/pc/Home_cote_pc.vue');
const Home_cote_pc = () => import('./views/pc/Home_cote_pc.vue');
// const PrivateClient_cote_mob = () => import('./views/mobile/PrivateClient_cote_mob.vue' );
// const About_us_cote_mob = () => import('./views/mobile/About_us_cote_mob.vue' );
// const Flagship_service_cote_mob = () => import('./views/mobile/Flagship_service_cote_mob.vue' );

Vue.use(Router)

export default new Router ({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
	// {
	// 	path: '/',
	// 	redirect:'/initpage_pc'
	// },
	{
		path: '/',
		name:'home_cote_pc',
		component: Home_cote_pc
	},
	{
		path: '/initpage_pc',
		name:'initpage_pc',
		component: Home_cote_pc,
		// component: Home_cote_pc
	},
	{
    path: '*',
    redirect: '/'
    //allow to refresh.(also configure nginx on Server)
	},
	]
})
